import { useEffect, useState } from "react";
import { Stack, TextField, Button } from "@mui/material";

export default function InstanceForm({
  selectedRow,
  onChange,
  onSave,
  isAdmin,
  formState,
  setOpenDialog,
}) {
  const [formData, setFormData] = useState(formState);
  const [showCredentials, setShowCredentials] = useState(!selectedRow); // show by default if no selectedRow

  useEffect(() => {
    if (selectedRow?.id) {
      setFormData(selectedRow);
      setShowCredentials(false); // hide credentials by default when editing
    } else {
      setFormData(formState);
      setShowCredentials(true); // show when creating new
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRow?.id]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    const updated = { ...formData, [name]: value };
    setFormData(updated);
    // Optional: comment this if you want to sync only on save
    onChange(updated);
  };

  const handleSave = () => {
    onSave(formData);
  };

  return (
    <>
      <TextField
        label="Instance URL"
        name="url"
        fullWidth
        size="small"
        variant="outlined"
        margin="normal"
        value={formData.url || ""}
        onChange={handleChange}
      />

      {isAdmin && showCredentials && (
        <>
          <TextField
            label="API Key"
            name="apiKey"
            fullWidth
            size="small"
            variant="outlined"
            margin="normal"
            value={formData.apiKey|| ""}
            onChange={handleChange}
          />

          <TextField
            label="Secret Key"
            name="secretKey"
            type="password"
            fullWidth
            size="small"
            variant="outlined"
            margin="normal"
            value={formData.secretKey|| ""}
            onChange={handleChange}
          />
        </>
      )}

      <Stack
        direction="row"
        spacing={2}
        padding={1}
        justifyContent="space-between"
      >
        {isAdmin && !!selectedRow?.id && (
          <Button
            color="error"
            variant="contained"
            onClick={() => setOpenDialog(true)}
            sx={{ mt: 2 }}
          >
            Delete
          </Button>
        )}

        <Stack direction="row" gap={2}>
          {isAdmin && !showCredentials && selectedRow?.id && (
            <Button variant="outlined" onClick={() => setShowCredentials(true)}>
              Edit Credentials
            </Button>
          )}

          <Button color="success" variant="contained" onClick={handleSave}>
            Save
          </Button>
        </Stack>
      </Stack>
    </>
  );
}
